/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';
import type { IAPNATUREOFPERSON } from './IAPNATUREOFPERSON';
import {
    IAPNATUREOFPERSONFromJSON,
    IAPNATUREOFPERSONFromJSONTyped,
    IAPNATUREOFPERSONToJSON,
} from './IAPNATUREOFPERSON';

/**
 * 
 * @export
 * @interface CompanyPartyDetailsViewModel
 */
export interface CompanyPartyDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof CompanyPartyDetailsViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {IAPNATUREOFPERSON}
     * @memberof CompanyPartyDetailsViewModel
     */
    natureOfCompanyId?: IAPNATUREOFPERSON;
    /**
     * 
     * @type {string}
     * @memberof CompanyPartyDetailsViewModel
     */
    registeredName?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPartyDetailsViewModel
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPartyDetailsViewModel
     */
    tradingName?: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof CompanyPartyDetailsViewModel
     */
    countryOfOperation?: IAPCOUNTRY;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof CompanyPartyDetailsViewModel
     */
    countryOfIncorporation?: IAPCOUNTRY;
    /**
     * 
     * @type {Date}
     * @memberof CompanyPartyDetailsViewModel
     */
    dateOfIncorporation?: Date;
}

/**
 * Check if a given object implements the CompanyPartyDetailsViewModel interface.
 */
export function instanceOfCompanyPartyDetailsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CompanyPartyDetailsViewModelFromJSON(json: any): CompanyPartyDetailsViewModel {
    return CompanyPartyDetailsViewModelFromJSONTyped(json, false);
}

export function CompanyPartyDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyPartyDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'natureOfCompanyId': !exists(json, 'NatureOfCompanyId') ? undefined : IAPNATUREOFPERSONFromJSON(json['NatureOfCompanyId']),
        'registeredName': !exists(json, 'RegisteredName') ? undefined : json['RegisteredName'],
        'registrationNumber': !exists(json, 'RegistrationNumber') ? undefined : json['RegistrationNumber'],
        'tradingName': !exists(json, 'TradingName') ? undefined : json['TradingName'],
        'countryOfOperation': !exists(json, 'CountryOfOperation') ? undefined : IAPCOUNTRYFromJSON(json['CountryOfOperation']),
        'countryOfIncorporation': !exists(json, 'CountryOfIncorporation') ? undefined : IAPCOUNTRYFromJSON(json['CountryOfIncorporation']),
        'dateOfIncorporation': !exists(json, 'DateOfIncorporation') ? undefined : (new Date(json['DateOfIncorporation'])),
    };
}

export function CompanyPartyDetailsViewModelToJSON(value?: CompanyPartyDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'NatureOfCompanyId': IAPNATUREOFPERSONToJSON(value.natureOfCompanyId),
        'RegisteredName': value.registeredName,
        'RegistrationNumber': value.registrationNumber,
        'TradingName': value.tradingName,
        'CountryOfOperation': IAPCOUNTRYToJSON(value.countryOfOperation),
        'CountryOfIncorporation': IAPCOUNTRYToJSON(value.countryOfIncorporation),
        'DateOfIncorporation': value.dateOfIncorporation === undefined ? undefined : (value.dateOfIncorporation.toISOString()),
    };
}

